<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <!-- Jobs -->
    <div id="print" class="card-panel-main col-lg-9 mb-5  " style="transform: translateX(-19vw)">
      <div class="d-flex flex-nowrap no_print hide">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="d-flex justify-content-between ">
              <h2 style="font-size: 1.2vw !important;">
                لیست و نقشه ذینفعان

              </h2>
            </div>
            <form class="needs-validation" novalidate>
              <div class="row">
                <div class="col-lg-2 mb-3 ms-n-08" style="width: 9vw;">
                  <label class="form-label">عنوان دسته</label>
                  <input class="form-control" v-model="nameCat" required>
                </div>
                <div class="col-lg-2 mb-3 ms-n-08" style="width: 9vw;">
                  <label class="form-label">عنوان انگلیسی</label>
                  <input class="form-control" v-model="title_en" required>
                </div>
                <div style="width: 9vw;" class="col-lg-2 mb-3 ms-n-08">
                  <label class="form-label">نحوه کدگذاری </label>
                  <select class="form-select" v-model="encodingMethodCat" required>
                    <option value="" disabled selected>انتخاب کنید</option>
                    <option value="حرف اختصاری">حرف اختصاری</option>
                    <option value="عدد">عدد</option>
                    <option value="حرف اختصاری و عدد">حرف اختصاری و عدد</option>
                  </select>
                </div>
                <div style="width: 9vw;" class="col-lg-2 mb-3 ms-n-08">
                  <label class="form-label">ذی نفع   </label>
                  <select class="form-select" v-model="is_exit" required>
                    <option value="" disabled selected>انتخاب کنید</option>
                    <option :value="true">بیرونی</option>
                    <option :value="false">درونی</option>
                  </select>
                </div>
                <div style="width: 8vw;" class="col-lg-2 mb-3 ms-n-08">
                  <label class="form-label">حرف اختصاری</label>
                  <input :disabled="encodingMethodCat==='عدد'" :placeholder="encodingMethodCat==='عدد' ? 'ندارد' : ''"
                         class="form-control" v-model="shortNameCat">
                </div>

                <div style="width: 10vw;" class="col-lg-2 mb-3 ms-n-08">
                  <label class="form-label"> سطوح زیرمجموعه</label>
                  <input readonly @click="addNewSelectedSub" :placeholder="subLevelsPlaceholder" type="text" class="form-control">
                </div>
                <div class="col-lg-2 mb-3 ms-n-08">
                  <label class="form-label">سطح تعریف شناسنامه </label>
                  <input readonly @click="addNewIdCard" :placeholder="idCardPlaceholder" type="text" class="form-control">
                </div>

                <div style="margin-top: 1.8vw;" class="col-lg-1 mb-3 d-flex">
                  <button class="btn btn-primary btn-submit-1" type="button" @click="addCategory"><p
                      style="font-size: 1.8vw; transform: translateY(.80vw)">+</p></button>
                </div>

              </div>


            </form>
            <hr>


          </div>
        </div>
      </div>
      <div v-show="allProcesses.length" class="row">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="row d-flex justify-content-start">
              <h2 style="font-size: 1.2vw !important;width: 15vw;">
                لیست جامع ذی نفعان

              </h2>
            </div>
            <form class="needs-validation mt-2 mb-3" novalidate>
              <div class="row">

                <div style="transform: translateY(-1.5vw)" class="hide col-lg-12 mb-3 no_print">
                  <input v-model="searchProcesses" type="text" class="form-control" style="width: 20vw;"
                         placeholder="جستجو بر اساس عنوان و کد  ...">
                </div>
              </div>
              <hr style="transform: translateY(-1.9vw)">

            </form>
            <div style="transform: translateY(-1.5vw)" class="table-responsive">
              <table v-show="allProcesses.length" class="table table-striped">
                <thead>
                <tr>
                  <th>ردیف</th>
                  <th>عنوان</th>
                  <th>معادل انگلیسی عنوان</th>
                  <th>سطح ذی نفع</th>
                  <th>کد</th>
                  <th class="no_print hide" style="width: 14vw;">عملیات‌ها</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in filteredItems" :style="setcolor(item['level'])">
                  <td scope="row">{{ index + 1 }}</td>
                  <td style="text-align: right">{{ item['title'] }}</td>

                  <td v-if="item['title_en']"> {{ item['title_en'] }}</td>
                  <td v-else>
                    --
                  </td>
                  <td v-if="item['type']">
                    <span v-if="item['type']==1"> ذی نفع</span>

                    <span v-else-if="item['type']==2">

                      گروه
                    </span>

                  </td>
                   <td v-else>
                    دسته
                  </td><td>{{ item['code'] }}</td>
                  <td class="no_print hide">
                    <div class="d-flex  justify-content-end">
                      <a
                          v-show="showIdCard(item['idcard_group']  ,item['idcard_floor']  ,item['type'])"
                          href="#"><img style="margin-right: .5vw;" class="table-edit-img" src="/img/id.02f9043a.svg"
                                        alt="prev"></a>
                      <a
                          @click.prevent="previousTree(item['id'])"
                          href="#"><img style="margin-right: .5vw;" class="table-edit-img"
                                        src="../../assets/img/prev.svg"
                                        alt="prev"></a>
                      <a
                          @click.prevent="nextTree(item['id'])"

                          href="#"><img style="margin-right: .5vw;" class="table-edit-img"
                                        src="../../assets/img/next.svg"
                                        alt="next"></a>
                      <a @click.prevent="editMethod(item['id'])" href="#"><img style="margin-right: .5vw;"
                                                                               class="table-edit-img"
                                                                               src="../../assets/img/pen.svg"
                                                                               alt="edit"></a>
                      <a @click.prevent="deleteItemModal(item['id'])" href="#"><img style="margin-right: .5vw;"
                                                                                    class="table-delete-img"
                                                                                    src="../../assets/img/delete.svg"
                                                                                    alt="delete"></a>
                      <a v-if="item['type']!=1" href="#"
                         @click.prevent="parseInt(item['type'])!==1 ? addParentProcessesMethod(item['id'], item['type']) : ''"
                         style="display:inline-block; transform: translateY(.1vw); width: 1.5vw; height: 1.5vw;margin-right: .5vw; text-decoration: none; font-size: 1.1vw; background-color: green; border-radius: 50%;  color: white;text-align: center;">+</a>
                    </div>
                  </td>
                </tr>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-show="table_all_Processes.length">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="row d-flex justify-content-start mb-3 w-100">
              <div class="d-flex justify-content-between align-items-center">
                <h2 style="font-size: 1.2vw !important;width: 9vw;">نقشه ذی نفعان</h2>
                <img @click="showMore=!showMore"
                     style="transition: transform ease 500ms;   width: 2vw; height: 2vw; transform: rotate(-90deg); cursor: pointer;"
                     :style="showMore ? 'transform: rotate(90deg);' : ''" class="me-2 no_print hide"
                     src="/img/left-arrow.8e96c359.svg" alt="left-arrow">


              </div>
            </div>
            <center v-show="showMore">
              <div
                  v-show="showMoreForCircle"
                  class="circle_process"
                  :style="changeItem(index)"
                  style="margin-bottom: 1vw; background-color: rgb(55, 66, 250); border-radius: 50%"
                  v-for="(item, index) in table_all_Processes"
              >
                <p>{{ item.title }}</p>
                <div>
                  <div
                      :class="'circle_group_'+index"
                      class="circle_group"
                      v-for="g in item.groups"
                  >
                    <p>{{ g.title }}</p>
                  <div style="transform: translateY(-1vw) translateX(-0.5vw)" class="d-flex">
                      <span class="span" v-for="k in g.floor">
                {{ k.title }}
            </span>
                  </div>
                  </div>
                </div>
              </div>


              <div
                  v-show="!showMoreForCircle"
                  class="circle_process"
                  :style="changeItemV2(index)"
                  style="margin-bottom: 1vw; background-color: rgb(55, 66, 250); border-radius: 50%"
                  v-for="(item, index) in table_all_Processes"
              >
                <p>{{ item.title }}</p>
                <div
                    :class="'circle_group_v2_'+index"
                    class="d-flex flex-wrap w-75" style="transform: translateX(-.5vw) translateY(8vw)">
                  <div
                      style="margin: .5vw; width:10vw; height: 10vw;"


                      class="circle_group"
                      v-for="g in item.groups"
                  >
                    <p>{{ g.title }}</p>
                  <div style="transform: translateY(-1vw) translateX(-0.5vw)" class="d-flex flex-wrap">
                      <span style="margin: .5vw;" class="span" v-for="k in g.floor">
                {{ k.title }}
            </span>
                  </div>
                  </div>
                </div>
              </div>

            </center>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="openModalsubLevelsCat" style="z-index: 999999999999999">
    <div>
      <p>انتخاب سطوح زیرمجموعه</p>
      <p @click="openModalsubLevelsCat=!openModalsubLevelsCat">❌</p>
    </div>
    <div>
      <div style="background-color: #fff; width: 25vw; padding: 1vw; border-radius: 1vw">
        <p class="text-end" style="transform: translateX(2vw)">
          <label style="font-size: 1vw; margin-right: 2vw;">
            <input v-model="subLevelsCat2" type="checkbox" value="گروه">
            گروه
          </label>
        </p>
        <p class="text-end">
          <label style="font-size: 1vw">
            <input v-model="subLevelsCat1" type="checkbox" value="ذی نفع">
            ذی نفع
          </label>
        </p>


      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="openModalsubLevelsCat=!openModalsubLevelsCat" class="btn btn-primary btn-back" type="submit">
          برگشت
        </button>
        <button class="btn btn-primary btn-approve" @click="removeModalSelectedSub">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!--  *******************************-->
  <!--  *******************************-->

  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="modalTitleFa" style="z-index: 999999999999999">
    <div>
      <p>ویرایش عنوان</p>
      <p @click="modalTitleFa=!modalTitleFa">❌</p>
    </div>
    <div>
      <div>
        <input v-model="title_for_edit_fa" placeholder="عنوان خود را وارد کنید" type="text" class="form-control"
               style="width: 20vw;">
      </div>
      <button @click="updateTitles(this.ProcessesId)">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="modalTitleEn" style="z-index: 999999999999999">
    <div>
      <p>ویرایش عنوان انگلیسی</p>
      <p @click="modalTitleEn=!modalTitleEn">❌</p>
    </div>
    <div>
      <div>
        <input v-model="title_for_edit_en" placeholder="عنوان انگلیسی خود را وارد کنید" type="text" class="form-control"
               style="width: 20vw;">
      </div>
      <button @click="updateTitles(ProcessesId)">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!--  *******************************-->
  <!--  *******************************-->

  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(ProcessesId)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!--  *******************************-->
  <!--  *******************************-->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="addParentProcesses" style="z-index: 999999999999999">
    <div>
      <p>افزودن زیرمجموعه {{ itemProcesses.category }}</p>
      <p @click="addParentProcesses=!addParentProcesses">❌</p>
    </div>
    <div>
      <div>
        <div class="d-flex">
          <div>
            <label style="font-size: .88vw; text-align: right;width: 100%;">عنوان</label>
            <input v-model="title_for_edit_fa_processes" placeholder="عنوان خود را وارد کنید" style="width: 13vw;"
                   type="text" class="form-control">
          </div>
          <div style="font-size: .88vw; text-align: right">
            <label>عنوان انگلیسی</label>
            <input v-model="title_for_edit_en_processes" placeholder="عنوان انگلیسی را وارد کنید"
                   style="width: 13vw; margin-right: 1vw;" type="text" class="form-control">
          </div>
        </div>
        <br>
        <label style="font-size: .88vw; text-align: right;width: 100%;">سطح ذی نفع </label>
        <select v-model="levelSub_processes" class="form-select">
          <option selected v-if="itemProcesses.is_group && is_group_select" value="2">گروه</option>
          <option selected v-if="itemProcesses.is_floor && is_floor_select" value="1">ذی نفع</option>

        </select>
      </div>

      <button @click="SubmitParent">تایید</button>
    </div>
  </div>
  <!-- modal  -->


  <div dir="rtl" class="modal__error slide-top" v-show="openModalsubLevelsCatForIdCard"
       style="z-index: 999999999999999">
    <div>
      <p>سطح تعریف شناسنامه</p>
      <p @click="openModalsubLevelsCatForIdCard=!openModalsubLevelsCatForIdCard">❌</p>
    </div>
    <div>
      <div style="background-color: #fff; width: 25vw; padding: 1vw; border-radius: 1vw">

        <p v-show="subLevelsCat2" class="text-end" style="transform: translateX(2vw)">
          <label style="font-size: 1vw; margin-right: 2vw;">
            <input v-model="subLevelsCat2_id" type="checkbox" value="true">
            گروه
          </label>
        </p>
        <p v-show="subLevelsCat1" class="text-end">
          <label style="font-size: 1vw">
            <input v-model="subLevelsCat3_id" type="checkbox" value="true">
            ذی نفع
          </label>
        </p>

      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="openModalsubLevelsCatForIdCard=!openModalsubLevelsCatForIdCard" class="btn btn-primary btn-back"
                type="submit">
          برگشت
        </button>
        <button class="btn btn-primary btn-approve"
                @click="openModalsubLevelsCatForIdCard=!openModalsubLevelsCatForIdCard">تایید
        </button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!--  *******************************-->
  <!--  *******************************-->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="editModal" style="z-index: 999999999999999">
    <div>
      <p>ویرایش</p>
      <p @click="editModal=!editModal">❌</p>
    </div>
    <div>
      <div>
        <div class="d-flex">
          <div>
            <label style="font-size: .88vw; text-align: right;width: 100%;">عنوان</label>
            <input v-model="title_for_edit_fa" placeholder="عنوان خود را وارد کنید" style="width: 13vw;" type="text"
                   class="form-control">
          </div>
          <div style="font-size: .88vw; text-align: right">
            <label>عنوان انگلیسی</label>
            <input v-model="title_for_edit_en" placeholder="عنوان انگلیسی را وارد کنید"
                   style="width: 13vw; margin-right: 1vw;" type="text" class="form-control">
          </div>
        </div>

        <br>
        <label v-if="levelSub" style="font-size: .88vw; text-align: right;width: 100%;">سطح ذی نفع </label>
        <select v-if="levelSub" v-model="levelSub" class="form-select">
          <option value="" selected disabled>انتخاب کنید</option>
          <option v-if="itemProcesses.is_group" value="2">گروه</option>
          <option v-if="itemProcesses.is_floor" value="1">ذی نفع</option>
        </select>
      </div>
      <button @click="updateForm(ProcessesId)">تایید</button>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="Error" style="z-index: 999999999999999">
    <div>
      <p>خطا</p>
      <p @click="Error=!Error">❌</p>
    </div>
    <div>
      <p>{{ ErrorM }}</p>
      <button @click="Error=!Error">تایید</button>
    </div>
  </div>
  <!-- modal  -->
</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import router from "@/router";
import {useToast} from "vue-toastification";
const toast = useToast();

export default {
  name: "process_map",
  components: {Sidebar, Splash},
  data() {
    return {

      //*******************************
      //*******************************
      // todo: for categories *******************************
      // *******************************
      categories: [],
      nameCat: '',
      shortNameCat: '',
      encodingMethodCat: '',
      type_cat: '',
      level_cardid: '',
      title_en: '',
      subLevelsCat1: '',
      subLevelsCat2: '',
      sub_id: 0,
      isValueChainCat: false,
      openModalsubLevelsCat: false,
      // todo: for categories *******************************
      //*******************************
      // *******************************
      Error: false,
      ErrorM: '',
      // *******************************
      // *******************************
      // todo: for Processes *******************************
      allProcesses: [],
      searchProcesses: '',
      ProcessesId: '',
      addParentProcesses: false,
      modalTitleEn: false,
      modalTitleFa: false,
      editModal: false,
      deleteModal: false,
      showMore: false,
      showMoreForCircle: true,
      title_for_edit: '',
      title_for_edit_fa: '',
      levelSub: '',
      title_for_edit_en: '',
      itemProcesses: [],
      table_all_Processes: [],
      table_all_Processes_floor: [],
      table_all_Processes_groups: [],
      table_all_Processes_process: [],
      table_all_Processes_sub_process: [],

      title_for_edit_fa_processes: '',
      title_for_edit_en_processes: '',
      levelSub_processes: '',
      //*******************************
      table_all_Processes_by_group: [],
      table_all_Processes_groups_by_group: [],
      table_all_Processes_process_by_group: [],
      table_all_Processes_sub_process_by_group: [],
      //*******************************
      table_all_Processes_by_processes: [],
      table_all_Processes_process_by_processes: [],
      table_all_Processes_sub_process_by_processes: [],
      //*******************************
      table_all_Processes_by_sub_process: [],
      table_all_Processes_sub_process_by_sub_process: [],

      is_floor_select: false,
      is_group_select: false,
      is_process_select: false,
      is_sub_process_select: false,
      subLevelsCat2_id: '',
      subLevelsCat3_id: '',
      is_exit: '',
      openModalsubLevelsCatForIdCard: false,

      // todo: for Processes *******************************
      //*******************************
      //*******************************

    };
  },
  methods: {
    changeItem(index) {
      if (index === 1) {
        return 'transform: translateY(-65.8vw); border: 1px solid; height: 60vw !important; width: 60vw !important;';
      } else if (index === 2) {
        return 'transform: translateY(-121.5vw); border: 1px solid; height: 50vw !important; width: 50vw !important;';
      } else if (index === 3) {
        return 'transform: translateY(-167.5vw); border: 1px solid; height: 40vw !important; width: 40vw !important;';
      } else if (index === 4) {
        return 'transform: translateY(-203vw); border: 1px solid; height: 30vw !important; width: 30vw !important;';
      } else {
        return 'height: 70vw; width: 70vw;'
      }
    },
    printMethod() {


    },
    editMethod(id) {
      this.edit(id)
      this.ProcessesId = id
      this.editModal = true
    },
    nextTree(id) {


      fetch(`${this.base_url}/beneficiary/change_tree/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response.error) {
              this.ErrorM = response.error
              toast.error(this.ErrorM)
              return
            }
            this.fetchAllProcesses()
          }).catch((err) => {
        console.log(err)
      })


    },
    showIdCard(is_group, is_floor, type) {
      let typeNumber = parseInt(type)

      if (is_group && typeNumber === 2) {
        return true

      } else if (is_floor && typeNumber === 1) {
        return true

      }
      return false
    },
    previousTree(id) {


      fetch(`${this.base_url}/beneficiary/change_tree/${id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: {
          'type': 'previous'
        }
      })
          .then(response => response.json())
          .then((response) => {
            if (response.error) {

              this.ErrorM = response.error
              toast.error(this.ErrorM)

              return
            }
            this.fetchAllProcesses()
          }).catch((err) => {
      })

    },
    setcolor(level) {

      if (level === 0) {
        return `background: #86D1FF !important`

      }


      if (level === 1) {
        return 'background: #bce6ff !important'

      }
      if (level === 2) {
        return 'background: #d9f1ff !important'

      } else {
        return 'background: rgba(#d9f1ff, 40%) !important'
      }


    },

    addParentProcessesMethod(id, type) {
      this.edit(id)
      if (type == null) {
        this.is_floor_select = true
        this.is_group_select = true
        this.is_process_select = true
        this.is_sub_process_select = true

      }
      if (type == 2) {
        this.is_floor_select = true
        this.is_group_select = false
      }
      if (type == 1) {
        this.is_floor_select = false
        this.is_group_select = false

      }


      this.addParentProcesses = true
      this.itemProcesses.length = 0
      this.title_for_edit_fa = ''
      this.levelSub = ''
      this.title_for_edit_en = ''
      this.ProcessesId = id
      this.title_for_edit_fa_processes = ''
      this.title_for_edit_en_processes = ''
      this.levelSub_processes = ''

    },
    SubmitParent() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('title', this.title_for_edit_fa_processes);
      formdata.append('title_en', this.title_for_edit_en_processes);
      formdata.append('levelSub', this.levelSub_processes);


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/beneficiary/store_parent/${this.ProcessesId}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            this.categories.length = 0
            this.fetchAllProcesses()
            this.addParentProcesses = !this.addParentProcesses


          })
          .catch();
    },
    deleteItemModal(id) {
      this.ProcessesId = id
      this.deleteModal = true

    },
    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/beneficiary/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {

              this.ErrorM = result.error
              toast.error(this.ErrorM)

              return
            }

            this.deleteModal = false
            this.table_all_Processes.length = 0
            this.table_all_Processes_groups.length = 0
            this.table_all_Processes_floor.length = 0
            this.allProcesses.length = 0
            this.fetchAllProcesses()

          })
          .catch();


    },
    fetchAllProcesses() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/beneficiary/all`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {

              this.ErrorM = result.error
              toast.error(this.ErrorM)

              return
            }
            if (result.items.length) {
              this.allProcesses.length = 0
              result.items.forEach((ele) => {
                this.allProcesses.push(ele)


              })
            }


          })
          .catch();

      fetch(`${this.base_url}/beneficiary/all_table`, requestOptions)
          .then(response => response.json())
          .then(result => {

            if (result.items.length) {
              this.table_all_Processes.length = 0
              this.table_all_Processes_groups.length = 0
              this.table_all_Processes_floor.length = 0
              result.items.forEach((ele) => {
                this.table_all_Processes.push(ele)
                this.methodShow()


              })
              /* result.groups.forEach((ele) => {
                 this.table_all_Processes_groups.push(ele)

               })*/

              result.floor.forEach((ele) => {
                this.table_all_Processes_floor.push(ele)

              })
            }


          })
          .catch();
      fetch(`${this.base_url}/beneficiary/all_table_by_group`, requestOptions)
          .then(response => response.json())
          .then(result => {

            if (result.items.length) {
              this.table_all_Processes_by_group.length = 0
              this.table_all_Processes_groups_by_group.length = 0
              this.table_all_Processes_process_by_group.length = 0
              this.table_all_Processes_sub_process_by_group.length = 0
              result.items.forEach((ele) => {
                this.table_all_Processes_by_group.push(ele)

              })
              result.groups.forEach((ele) => {
                this.table_all_Processes_groups_by_group.push(ele)

              })


            }


          })
          .catch();


    },
    editTitleFa(id) {
      this.title_for_edit_fa = ''

      this.ProcessesId = id
      this.modalTitleFa = true


    },
    updateTitles(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      if (this.title_for_edit_fa.length) {
        formdata.append('title', this.title_for_edit_fa)

      }
      if (this.title_for_edit_en.length) {
        formdata.append('title_en', this.title_for_edit_en)

      }
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/beneficiary/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {

              this.ErrorM = result.error
              toast.error(this.ErrorM)

              return
            }
            this.modalTitleFa = false
            this.modalTitleEn = false
            this.title_for_edit_fa = ''
            this.title_for_edit_en = ''
            this.fetchAllProcesses()


          })
          .catch();
    },
    updateForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('title', this.title_for_edit_fa)
      formdata.append('title_en', this.title_for_edit_en)
      formdata.append('type', this.levelSub)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/beneficiary/update_parent/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {

              this.ErrorM = result.error
              toast.error(this.ErrorM)

              return
            }

            this.editModal = false
            this.title_for_edit_fa = ''
            this.title_for_edit_en = ''
            this.fetchAllProcesses()


          })
          .catch();
    },
    editTitleEn(id) {
      this.ProcessesId = id
      this.title_for_edit_en = ''
      this.modalTitleEn = true

    },
    edit(id) {
      this.ProcessesId = id
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/beneficiary/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            this.itemProcesses = result.item
            if (result.item.is_group && !result.item.type) {
              this.levelSub_processes = 2
            } else {
              this.levelSub_processes = 1

            }
            this.title_for_edit_fa = result.item.title
            this.title_for_edit_en = result.item.title_en
            this.levelSub = result.item.type


          })
          .catch();
    },


    //*******************************
    //*******************************
    // todo: for categories *******************************
    SubmitSubCategories() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('categories', JSON.stringify(this.categories));


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/beneficiary/store`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {

              this.ErrorM = result.error
              toast.error(this.ErrorM)

              return
            }
            this.categories.length = 0
            this.fetchAllProcesses()


          })
          .catch();
    },
    addCategory() {
      if (!this.nameCat.length) {

        this.ErrorM = 'دسته اجباری است'
        toast.error(this.ErrorM)

        return
      }  else if (!this.encodingMethodCat.length) {

        this.ErrorM = 'نحوه کدگذاری   اجباری است'
        toast.error(this.ErrorM)

        return
      } else if (!this.subLevelsCat1 && !this.subLevelsCat2 && !this.subLevelsCat3 && !this.subLevelsCat4) {

        this.ErrorM = 'حداقل یک عناوین سطوح زیر مجموعه انتخاب کنید'
        toast.error(this.ErrorM)

        return
      }
      this.categories.push({
        name: this.nameCat,
        title_en: this.title_en,
        shortName: this.shortNameCat,
        encodingMethod: this.encodingMethodCat,
        subLevelsCat1: this.subLevelsCat1,
        subLevelsCat2: this.subLevelsCat2,
        subLevelsCat2_id: this.subLevelsCat2_id,
        subLevelsCat3_id: this.subLevelsCat3_id,
        is_exit: this.is_exit,
      });
      this.SubmitSubCategories()
      this.nameCat = ''
      this.shortNameCat = ''
      this.encodingMethodCat = ''
      this.subLevelsCat1 = ''
      this.subLevelsCat2 = ''
      this.title_en = ''
      this.subLevelsCat2_id = ''
      this.subLevelsCat3_id = ''
      this.is_exit = ''
    },
    removeCategory(index) {
      this.categories.splice(index, 1);
    },
    showSelectedSubCatMethod(id, subLevelsCat1, subLevelsCat2) {
      this.subLevelsCat1 = subLevelsCat1
      this.subLevelsCat2 = subLevelsCat2
      this.openModalsubLevelsCat = true
      this.sub_id = id


    },
    showSelectedSubCatIdCardMethod(subLevelsCat2, subLevelsCat3, subOne, subTwo) {
      this.subLevelsCat1 = subOne
      this.subLevelsCat2 = subTwo
      this.subLevelsCat2_id = subLevelsCat2
      this.subLevelsCat3_id = subLevelsCat3
      this.openModalsubLevelsCatForIdCard = true


    },
    addNewIdCard() {
      this.subLevelsCat2_id = ''
      this.subLevelsCat3_id = ''
      this.openModalsubLevelsCatForIdCard = true
    },
    addNewSelectedSub() {
      this.subLevelsCat1 = ''
      this.subLevelsCat2 = ''
      this.openModalsubLevelsCat = true


    },
    removeModalSelectedSub() {
      this.openModalsubLevelsCat = false

      this.categories.forEach((element, index) => {
        if (index === this.sub_id) {
          element.subLevelsCat1 = this.subLevelsCat1;
          element.subLevelsCat2 = this.subLevelsCat2;

        }
      })
      this.sub_id = 0
    },
    // todo: for categories *******************************
    //*******************************
    //*******************************
    methodShow(){
      if (this.table_all_Processes.length){
        if (this.table_all_Processes.length>3){
          return this.showMoreForCircle=true;
        }
      }





      return this.showMoreForCircle=false;
    },
    changeItemV2(index) {
      if (index === 1) {
          return 'transform: translateX(1vw) translateY(-51.5vw); border: 1px solid; height: 50vw !important; width: 50vw !important; padding:1vw';
      } else if (index === 2) {
        return 'transform: translateX(1.5vw) translateY(-82.7vw); border: 1px solid; height: 30vw !important; width: 30vw !important;';
      }    else {
        return 'height: 70vw; width: 70vw;'
      }
    },
    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
        return;
      }

    }
  },
  mounted() {
    this.checkIsMother()
    this.fetchAllProcesses()

  },
  computed: {
    filteredItems() {
      return this.allProcesses.filter(item => {
        if (this.searchProcesses) {
          const titleIncludes = item['title'] && item['title'].includes(this.searchProcesses);
          const categoryIncludes = item['category'].includes(this.searchProcesses);
          const code = item['code'].includes(this.searchProcesses);

          return titleIncludes || categoryIncludes || code;
        } else {
          return true; // در صورتی که searchProcesses خالی باشد، همه موارد نمایش داده شوند.
        }
      });
    },
    subLevelsPlaceholder() {
      if (this.subLevelsCat1 && this.subLevelsCat2) {
        return 'ذی نفع / گروه';
      } else if (this.subLevelsCat1) {
        return 'ذی نفع';
      } else if (this.subLevelsCat2) {
        return 'گروه';
      } else {
        return 'انتخاب کنید';
      }
    },
    idCardPlaceholder() {
      if (this.subLevelsCat2_id && this.subLevelsCat3_id) {
        return 'ذی نفع / گروه';
      } else if (this.subLevelsCat2_id) {
        return 'گروه';
      } else if (this.subLevelsCat3_id) {
        return 'ذی نفع';
      } else {
        return 'انتخاب کنید';
      }
    }
  }

}
</script>

<style scoped lang="scss">
.circle_group_v2_0{
  transform: translateX(-4.5vw) translateY(6.5vw) !important;
  width: 40vw !important;
}
.row {
  padding: .5vw;
}

@media print {
  .no-print, .hide {
    display: none;
  }

}


.circle_group:not([style*="display: none"]) {
  background-color: #5e67fc;
  width: 5vw;
  height: 5vw;
  border-radius: 50%;
  transform: translateY(-7vw);



}
.span
{
  width: 2vw;
  height: 2vw;
  border-radius: 50%;
  background-color: #b5b8fc;
  font-size: .4vw;
  display: flex;
  justify-content: center;
  align-items: center;


}

.circle_group_0:nth-child(1) {
  transform: translateX(4vw) translateY(-2.5vw);

}

.circle_group_0:nth-child(2) {
  transform: translateY(-6vw) translateX(-11vw);
}

.circle_group_0:nth-child(3) {
  transform: translateY(-8.5vw) translateX(16vw);

}

.circle_group_0:nth-child(4) {
  transform: translateY(-10vw) translateX(-21vw);
}

.circle_group_0:nth-child(5) {
  transform: translateY(-10vw) translateX(25.5vw);
}

.circle_group_0:nth-child(6) {
  transform: translateY(-10vw) translateX(-28.8vw);
}

.circle_group_0:nth-child(7) {
  transform: translateY(-10vw) translateX(30.9vw);
}

.circle_group_0:nth-child(8) {
  transform: translateY(-9.5vw) translateX(-32.2vw);
}
.circle_group_0{
  &:nth-child(9) {
    transform: translateY(-8.5vw) translateX(32.4vw);

  } &:nth-child(10) {
    transform: translateY(0.5vw) translateX(28.4vw);
  }
  &:nth-child(11) {
    transform: translateY(5.8vw) translateX(19.4vw);

  }&:nth-child(12) {
    transform: translateY(7vw) translateX(-1.6vw);

  }&:nth-child(13) {
    transform: translateY(-6vw) translateX(-21.8vw);

  }&:nth-child(14) {
    transform: translateY(-26.5vw) translateX(-31.3vw);

  }
}


.circle_group_1 {
  &:nth-child(1) {
    transform: translateX(-8vw) translateY(-1.7vw);

  }

  &:nth-child(2) {
      transform: translateX(9vw) translateY(-6.3vw);


  }
  &:nth-child(3) {
    transform: translateX(18.9vw) translateY(-5.4vw);


  }&:nth-child(4) {
    transform: translateX(-18.5vw) translateY(-10.4vw);


  }
  &:nth-child(5) {
    transform: translateX(25.5vw) translateY(-5.4vw);


  }
  &:nth-child(6) {
    transform: translateX(27.2vw) translateY(3.4vw);


  }  &:nth-child(7) {
    transform: translateX(22.5vw) translateY(10.4vw);


  }&:nth-child(8) {
    transform: translateX(10vw) translateY(15.4vw);


  }
  &:nth-child(9) {
    transform: translateX(-8vw) translateY(11vw);

  }
  &:nth-child(10) {
    transform: translateX(-18vw) translateY(0.2vw);

  }
  &:nth-child(11) {
    transform: translateX(-25vw) translateY(-14vw);

  }&:nth-child(12) {
    transform: translateX(-27.5vw) translateY(-28vw);

  }&:nth-child(13) {
    transform: translateX(-25.5vw) translateY(-45vw);

  }
  &:nth-child(14) {
    display: none;

  }




}
.circle_group_2 {
  &:nth-child(1) {
    transform: translateX(-10vw) translateY(-.7vw);

  }

  &:nth-child(2) {
    transform: translateX(10vw) translateY(-5.5vw);

  }

  &:nth-child(3) {
    transform: translateX(19.5vw) translateY(-1.5vw);

  }

  &:nth-child(4) {
    transform: translateX(22.3vw) translateY(5vw);

  }

  &:nth-child(5) {
    transform: translateX(18.5vw) translateY(12vw);

  }
  &:nth-child(6) {
    transform: translateX(10.5vw) translateY(14.5vw);

  }
  &:nth-child(7) {
    transform: translateX(-1vw) translateY(11.8vw);

  }
  &:nth-child(8) {
    transform: translateX(-10.5vw) translateY(4.5vw);

  }  &:nth-child(9) {
         transform: translateX(-20.8vw) translateY(-13vw);

  }&:nth-child(10) {
            transform: translateX(-22.2vw) translateY(-29vw);

  }&:nth-child(11) {
    transform: translateX(-18vw) translateY(-44vw);

  }&:nth-child(12) {
                  display: none;

  }&:nth-child(13) {
                     display: none;

  }&:nth-child(14) {
                     display: none;

  }
}

.circle_group_3 {

  display: none;

  &:nth-child(1) {
    transform: translateX(12.2vw) translateY(2vw);
    display: block;


  } &:nth-child(2) {
    transform: translateX(-7.2vw) translateY(-6vw);
    display: block;


  } &:nth-child(3) {
    transform: translateX(-15.5vw) translateY(-3vw);
    display: block;


  }&:nth-child(4) {
    transform: translateX(-17.3vw) translateY(1vw);
    display: block;


  }
  &:nth-child(5) {
    transform: translateX(-12.2vw) translateY(7vw);
    display: block;


  }&:nth-child(6) {
    transform: translateX(-4.2vw) translateY(7vw);
    display: block;


  }&:nth-child(7) {
    transform: translateX(11vw) translateY(-2vw);
    display: block;


  }&:nth-child(8) {
    transform: translateX(16.3vw) translateY(-15vw);
    display: block;


  }&:nth-child(9) {
                transform:translateX(16.6vw) translateY(-30vw);
    display: block;


  }




}

.circle_group_4 {
  display: none;
  &:nth-child(1) {
    transform: translateX(9.8vw) translateY(2vw);
    display: block;


  } &:nth-child(2) {
      transform: translateX(-7.2vw) translateY(-5.5vw);
      display: block;


    } &:nth-child(3) {
        transform: translateX(-12.1vw) translateY(-3vw);
        display: block;


      }&:nth-child(4) {
         transform: translateX(-10.7vw) translateY(1vw);
         display: block;


       }
  &:nth-child(5) {
    transform: translateX(-3.2vw) translateY(1.5vw);
    display: block;


  }&:nth-child(6) {
     transform: translateX(6.2vw) translateY(-4.7vw);
     display: block;


   }&:nth-child(7) {
      transform: translateX(12vw) translateY(-18vw);
      display: block;


    }

}



</style>